import { deriveRouteShortName } from '#/transit-tracker/utils/routes';
import { FEEDS, LIGHT_RAIL_MODE, BUS_MODE } from '#/shared/constants';
import { lowerize } from './string';

/**
 * Convert a developer.trimet.org vehicle object to the
 * @opentripplanner/core-utils/types/transitVehicleType object format
 * @todo PRJ77-1450: Refine the presentation of the vehicle tooltip for non-Trimet real-time-vehicles
 *
 * @param {Object} rec - Vehicle record
 * @returns {Object} Converted vehicle result
 */
/**
 * @param {import('#/types/VehicleResult').VehicleRecord} rec
 */
export const convertRecord = rec => {
  const {
    feedId,
    vehicleID,
    blockID,
    routeNumber,
    tripID,
    direction,
    nextLocID,
    nextStopSeq,
    latitude,
    longitude,
    bearing,
    type,
    signMessage,
    routeColor,
  } = rec;
  const recordFeedId = feedId ?? FEEDS.TRIMET;
  const retVal = {
    agencyId: recordFeedId,
    id: `${vehicleID}+${blockID}`,
    vehicleId: String(vehicleID),
    routeId: routeNumber,
    blockId: `${recordFeedId}:${blockID}`,
    shapeId: null,
    tripId: String(tripID),
    directionId: String(direction),
    stopId: String(nextLocID),
    stopSequence: nextStopSeq,
    lat: latitude,
    lon: longitude,
    heading: bearing,
    routeType: type === 'rail' ? LIGHT_RAIL_MODE : BUS_MODE,
    routeShortName: deriveRouteShortName(recordFeedId, routeNumber),
    routeLongName: signMessage ?? '',
    routeColor: routeColor ? `#${routeColor}` : null,
  };

  return retVal;
};

/**
 * Make destination from a real-time vehicle record
 * @param {any} vehicle - Vehicle data
 * @param {boolean} pretty - Whether to format the destination nicely
 * @returns {string} Formatted destination
 */
export const destinationFromVehicleRecord = (vehicle, pretty = true) => {
  let destination = vehicle.routeLongName;

  // make destination sign pretty (ie lowercase 'to', remove bus # if it starts sign)
  if (pretty) {
    if (destination.startsWith(vehicle.routeShortName)) {
      destination = destination.replace(vehicle.routeShortName, '').trim();
    }
    if (vehicle.agencyId !== FEEDS.TRIMET && !destination.startsWith('To ')) {
      destination = `To ${destination}`;
    }
    if (destination.startsWith('To ')) {
      destination = lowerize(destination);
    }
  }

  return destination;
};
